import React, { useState } from "react";
import { IconButton, Checkbox } from "@mui/material";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Province } from "../../Province";
import moment from "jalali-moment";

// import JS files

// import others files

const ListCard = (props) => {
  return (
    <>
      <div className="my-2">
        <div className="bg-[#f8f8f8] rounded-lg text-xs">
          <div className="grid grid-cols-12 ">
            <div className="col-span-1 flex flex-col justify-between border-l p-2 border-dashed ">
              <div
                className="-mt-2 flex justify-between items-center w-full"
                onClick={() => props.update_options(props.data.id)}
              >
                <span className="">انتخاب:</span>
                <div className="mr-1">
                  <Checkbox
                    checked={
                      props.selectedOptions.length > 0
                        ? props.selectedOptions.filter(
                            (it) => it == props.data.id
                          ).length > 0
                        : false
                    }
                  />
                </div>
              </div>
              {props.status !== "confirmed" && (
                <>
                  <div className="mt-1 flex justify-between items-center w-full">
                    <span className="">تایید:</span>
                    <IconButton
                      aria-label="next"
                      className="confrim-btn"
                      onClick={() => props.confirmFunc(props.data)}
                    >
                      <ThumbUpOffAltIcon className="text-white" />
                    </IconButton>
                  </div>
                </>
              )}
              {props.status == "waiting" && (
                <div className="mt-2 flex justify-between items-center w-full">
                  <span className="ml-2">رد:</span>
                  <IconButton
                    aria-label="next"
                    className="reject-btn"
                    onClick={() => props.rejectFunc(props.data)}
                  >
                    <ThumbDownOffAltIcon className="text-white" />
                  </IconButton>
                </div>
              )}
              {props.status == "confirmed" && (
                <div className="mt-2 flex justify-between items-center w-full">
                  <span className="ml-2">برگشت:</span>
                  <IconButton
                    aria-label="next"
                    className="reject-btn"
                    onClick={() => props.returnFunc(props.data)}
                  >
                    <ArrowForwardIcon className="text-white" />
                  </IconButton>
                </div>
              )}
            </div>

            <div className="col-span-11 p-2 grid grid-cols-4 gap-4">
              <div className="border-b col-span-4 flex justify-between items-center pb-1">
                <div className="flex items-center">
                  <span className="text-mygreen-100 font-bold">
                    شماره پرونده: <span>{props.data.unique_id}</span>
                  </span>
                  <span className="text-mygreen-100 mr-4">
                    تاریخ درخواست:{" "}
                    <span>
                      {" "}
                      {moment(props.data.created_at, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </span>
                  </span>
                </div>
                <div className="flex">
                  {props.status == "failed" && (
                    <div className="flex justify-between items-center">
                      <span className="ml-2">دلیل رد:</span>
                      <IconButton
                        aria-label="next"
                        className="download-btn"
                        onClick={() => props.rejectDesFunc(props.data)}
                      >
                        <RemoveRedEyeIcon className="text-white" />
                      </IconButton>
                    </div>
                  )}

                  {/* <div className="mr-2 flex justify-between items-center">
                    <span className="ml-2">مدارک:</span>
                    <IconButton
                      aria-label="next"
                      className="download-btn"
                      onClick={() => props.showPicsFunc(props.data)}
                    >
                      <RemoveRedEyeIcon className="text-white" />
                    </IconButton>
                  </div> */}
                  <div className="mr-2 flex justify-between items-center">
                    <span className="ml-2">افراد تحت تکفل:</span>
                    <IconButton
                      aria-label="next"
                      className="download-btn"
                      onClick={() => props.showSubsFunc(props.data)}
                    >
                      <RemoveRedEyeIcon className="text-white" />
                    </IconButton>
                  </div>
                </div>
              </div>

              <span className="text-gray-500">
                نام و نام خانوادگی:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].first_name +
                    " " +
                    props.data.treatment_request_main_insured[0].last_name}
                </span>
              </span>
              <span className="text-gray-500">
                تاریخ تولد:{" "}
                <span className="text-gray-900">
                  {moment(
                    props.data.treatment_request_main_insured[0].birth_date,
                    "YYYY/MM/DD"
                  )
                    .locale("fa")
                    .format("YYYY/MM/DD")}
                </span>
              </span>
              <span className="text-gray-500">
                کد ملی:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].identity_num}
                </span>
              </span>
              <span className="text-gray-500">
                شماره شناسنامه:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].identity_num}
                </span>
              </span>
              <span className="text-gray-500">
                نام پدر:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].father_name}
                </span>
              </span>
              <span className="text-gray-500">
                استان محل تولد:{" "}
                <span className="text-gray-900">
                  {
                    Province.filter(
                      (it) =>
                        it.value ==
                        props.data.treatment_request_main_insured[0]
                          .birth_provience
                    )[0].name
                  }
                </span>
              </span>
              <span className="text-gray-500">
                شهر محل تولد:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].birth_city}
                </span>
              </span>
              <span className="text-gray-500">
                نوع تاهل:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].fa_marrige}
                </span>
              </span>
              <span className="text-gray-500">
                کد کارگزاری:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].personal_code}
                </span>
              </span>
              <span className="text-gray-500">
                کد بیمه‌ای دفتر کارگزاری:{" "}
                <span className="text-gray-900">
                  {
                    props.data.treatment_request_main_insured[0]
                      .broker_insurance_code
                  }
                </span>
              </span>
              <span className="text-gray-500">
                بیمه‌گر پایه:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].fa_insurance}
                </span>
              </span>
              <span className="text-gray-500">
                نوع طرح:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].fa_plan}
                </span>
              </span>
              <span className="text-gray-500">
                تاریخ استخدام:{" "}
                <span className="text-gray-900">
                  {moment(
                    props.data.treatment_request_main_insured[0]
                      .employment_date,
                    "YYYY/MM/DD"
                  )
                    .locale("fa")
                    .format("YYYY/MM/DD")}
                </span>
              </span>

              {/* <span className="text-gray-500">
                جنسیت:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].fa_gender}
                </span>
              </span> */}
              <span className="text-gray-500">
                بانک:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].fa_bank_code}
                </span>
              </span>
              <span className="text-gray-500">
                نوع حساب:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].fa_account_type}
                </span>
              </span>
              <span className="text-gray-500">
                صاحب حساب:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].owner_account_name}
                </span>
              </span>
              <span className="text-gray-500">
                شماره حساب:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].account_num}
                </span>
              </span>
              <span className="text-gray-500">
                شماره شبا:{" "}
                <span className="text-gray-900">
                  {props.data.treatment_request_main_insured[0].shaba_num}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListCard;
